<template>
  <TableRow>
    <TableCell
      :class="
        cn(
          'p-4 whitespace-nowrap align-middle text-sm text-foreground',
          props.class
        )
      "
      :colspan="props.colspan"
    >
      <div class="flex items-center justify-center py-10">
        <slot />
      </div>
    </TableCell>
  </TableRow>
</template>

<script>
import TableRow from './TableRow.vue';
import TableCell from './TableCell.vue';
import { cn } from '../../utils.js';

export default {
  components: {
    TableRow,
    TableCell,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    return { props, cn };
  },
};
</script>
